import { useMemo } from 'react'

import { getTranscriptDimensions } from 'src/components/constants'
import { useConfig } from 'src/contexts/ConfigurationContext'

import { useResponsive } from './useResponsive'

export const useTranscriptDimensions = (containerWidth: number) => {
    const [{ shouldDisplayLogo, isFullWidthMode }] = useConfig()
    const { isMobilePhone } = useResponsive()
    const dimensions = useMemo(
        () =>
            getTranscriptDimensions({
                containerWidth,
                isFullWidthMode,
                shouldDisplayLogo: shouldDisplayLogo && !isMobilePhone,
            }),
        [containerWidth, isFullWidthMode, isMobilePhone, shouldDisplayLogo],
    )

    return dimensions
}
